module.exports = __webpack_public_path__ + "img/loading.b8ffacf6.svg";